<template>
  <div class="sidebar-wrap" :style="styleObject" :class="$store.state.isCollapse?'coll-nav':'open-nav'">
    <el-scrollbar class="page-compoent__scroll">
      <div class="head-logo" :class="{'logo-dev':$EpetJs.Const.ENV != 'product'}">
      </div> 
      <div class="head-user-wrap">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <span class="cfff" v-show="!$store.state.isCollapse">{{ $store.state.userInfo.userName }}</span><i class="head-arrow"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updatepwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="updatePermission">刷新权限</el-dropdown-item>
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        :background-color="$store.state.themeColor"
        text-color="#fff"
        :collapse="$store.state.isCollapse"
        @open="handleOpen">
        <sidebar-item :sidebarData="sidebarList" @toPath="toPath"></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { commonApi } from '@/api/common'
import SidebarItem from './sidebaritem'
export default{
  data(){
    return{
      isCollapse:false
    }
  },
  props:['sidebarList'],
  components:{SidebarItem},
  computed:{
    styleObject(){
      return 'background-color:'+this.$store.state.themeColor
    }
  },
  created() {
    this.initMenu()
  },
  methods: {
    // 初始化菜单
    initMenu() {
      const permissionList = this.$store.state.permissionInfo.permissionList ? this.$store.state.permissionInfo.permissionList : []
      // 如果本地无任何权限，则初始获取目录
      if(permissionList.length == 0) {
        this.getPermissionData(0, 0)
      }
    },
    // 检测设置权限
    checkPermission(to) {
      const permissionList = this.$store.state.permissionInfo.permissionList ? this.$store.state.permissionInfo.permissionList : []
      //判断权限中是否有该条记录，如果存在，记录下当前路由的front_id
      const currentId = permissionList.find(v => {
        return v.component_name == to.name
      }) ? permissionList.find(v => {
        return v.component_name == to.name
      }).front_id : ''
      //获取下级权限
      if (currentId) {
        const front_type = this.$store.state.permissionInfo.permissionList.find(v => {
          return v.component_name == to.name
        }).front_type
        //如果本地没有该权限的下级权限，则请求接口获取
        if (!this.$store.state.permissionInfo.permissionList.some(v => {
          return v.parent_id == currentId
        })) {
          this.getPermissionData(front_type, currentId)
        }
      }
    },
    //获取权限数据
    getPermissionData(front_type, front_id) {
      switch (front_type) {
        //如果是目录，就获取目录下的菜单或模块
        case 0:case 1:
          this.getMenu(front_type,front_id)
          break
        //如果是菜单，就获取菜单下的按钮
        case 2:
          this.$store.dispatch('getBtns',front_id)
          break
        case 4:
          this.$store.dispatch('getBtns',front_id)
          break
      }
    },
    //获取菜单权限
    getMenu(front_type,front_id) {
      EpetJs.Common.ajax('get', `${commonApi.getMenu}/${this.$store.state.permissionInfo.backEndId}/${front_id}`).then(res => {
        if (res) {
          // 设置菜单
          this.setSideBarList(res.data.data || [],front_type,front_id)
          //保存权限列表
          this.$store.dispatch('saveLocalPermissionList',res.data.data)
        }
      })
    },
    // 设置菜单
    setSideBarList(data,front_type,front_id) {
      switch(front_type) {
        // 如果为0，则视为初始设置目录
        case 0:
          this.$store.commit("changeSidebarList", this.$store.state.permissionInfo.sidebarList.concat(data));
          break
        // 给目录下设置菜单
        case 1:
          const parentNav = this.$EpetJs.Common.findTree(this.$store.state.permissionInfo.sidebarList,'children','front_id',front_id)
          if(parentNav) {
            this.$set(parentNav,'children',data)
          }
          break
      }
    },
    // 点击菜单时，判断是否为目录，如果为目录，则继续获取下级菜单
    toPath(item) {
      if ((!item.children || item.children.length < 1) && item.front_type == 1) {
        this.getPermissionData(item.front_type,item.front_id)
      }
    },
    // 打开菜单，判断获取权限
    handleOpen(key, keyPath) {
      const front_id = this.$store.state.permissionInfo.permissionList.find(v => {return v.component_name == key}) ? this.$store.state.permissionInfo.permissionList.find(v => {return v.component_name == key}).front_id : ''
      const front_type = this.$store.state.permissionInfo.permissionList.find(v => {return v.component_name == key}) ? this.$store.state.permissionInfo.permissionList.find(v => {return v.component_name == key}).front_type : ''
      // 如果有front_id，说明菜单接入了权限，需进一步判断获取权限
      if(front_id) {
        // 如果已经存在当前权限的下级权限，则不做任何处理
        if(this.$store.state.permissionInfo.permissionList.some(v => { return v.parent_id == front_id })) {
          return false
        }
        this.getMenu(front_type,front_id)
      }
    },
    handleCommand(command){
      switch(command) {
        //退出登录
        case 'loginout':
            const logoutUrl = localStorage.getItem(EpetJs.Const.LoginTypeName) == 'business' ? commonApi.businessLogoutUrl : commonApi.commonLogout
          this.$EpetJs.Common.ajax('get', logoutUrl, {platform:this.$store.state.platformName}, {
            customError: true
          }).then(res=>{
            console.log(res, '返回数据')
            console.log(res.data.status_code, '返回数据状态码')
            if(res.data && ['200', '401'].includes(res.data.status_code)){
                console.log('处理退出登录')
              this.$store.commit('loginout');
              this.$router.push('/login');
              this.logout = true
              var targetWindow = document.getElementById('ssoLogin')
              targetWindow.contentWindow.postMessage('logout',this.$EpetJs.Const.PROTOCOL+'//sso.'+(this.$EpetJs.Const.ENV=='product'?'':this.$EpetJs.Const.ENV+'.')+'tapinpet.com')
            }
          })
          break
        //修改密码
        case 'updatepwd':
          this.$router.push('/reset?user_name='+this.$store.state.userInfo.userName)
          break
        // 刷新权限
        case 'updatePermission':
          this.$EpetJs.Common.confirm('是否确认刷新权限？','操作提示').then(()=>{
            Bus.$emit('initPermission')
          }).catch(()=>{})
          break
      }
    },
  },
  watch:{
    $route(newValue,oldValue){
      //console.log(newValue,111)
    }
  }
}
</script>
<style scoped>
>>> .el-scrollbar__wrap{
  overflow-x: hidden;
}
>>> .el-menu-item.is-active{
  background-color:#3e4550 !important;
  color:#fff;
}
</style>
<style>
.sidebar-wrap{
  position:fixed;
  left:0;
  top:0px;
  height:100%;
  transition:width .28s;
}
.coll-nav{
  width:65px;
}
.open-nav{
  width:160px;
}
.page-compoent__scroll{
  height:100%;
}
.el-menu{
  border-right:none !important;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 160px;
  min-height: 400px;
}
.el-submenu .el-menu-item{
  min-width:180px !important;
}

.el-menu--collapse .el-menu-item span, .el-menu--collapse .el-submenu .el-submenu__title span{
  height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
}
.head-logo{ height: 80px; background: url(./images/logo.png) 50% 0 no-repeat; margin-left:-17px;}
.coll-nav .head-logo{ background-position: 42% -85px }
.logo-dev{ background-position: 50% -170px;  }
.coll-nav .logo-dev{ background-position: 42% -260px }
.head-user-wrap{
  padding: 10px 0 10px 20px;
  color:#fff;
  background-color:rgb(40, 46, 56);
}
.head-arrow{ display: inline-block; width: 16px; height: 16px; background: url(./images/arrow.png) 0 0 no-repeat; vertical-align: middle; margin-left: 5px;}
</style>
